<!--AFFICHAGE BLOC RGE -->
<template>
  <v-col
      md="12"
      class="pa-3 d-flex flex-column"
      v-if="this.condition()"

  >
              <a class="anchor" id="blocrge"></a>

    <v-card elevation="2">
      <v-card-title>Etablissement Certifié France Renov</v-card-title>
      <v-card-text>
        <a href="https://france-renov.gouv.fr/annuaire-rge" target="_blank">
          <img
              title="Etablissement certifié RGE"
              src="../../assets/logo_france_renov.png"
          />
        </a>


        <a :href="certif_rge.urlcertificat" target="_blank">
            <v-chip
                class="ma-2"
                color="grey"
                text-color="white"
            >
              <v-avatar left>
                <v-icon>mdi-file-pdf-box</v-icon>
              </v-avatar>
              <span>Certificat {{certif_rge.nomcertificat}} Délivré par {{certif_rge.organisme}}</span>
            </v-chip>
          </a>



        <v-container fluid v-if="this.condition()">
          <v-row dense>

        <v-simple-table>
          <thead>
          <tr>
            <th class="text-left">
              Méta domaine
            </th>
            <th class="text-left">
              Domaine
            </th>
            <th class="text-left">
              Qualification
            </th>

          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(item, index) in certif_rge.qualifications"
              :key=index
          >
            <td>{{ item.meta_domaine }}</td>
            <td>{{ item.domaines }}</td>
            <td>{{ item.qualifications }}</td>



          </tr>
          </tbody>
        </v-simple-table>


          </v-row>
        </v-container>

      </v-card-text>
    </v-card>

  </v-col>
</template>

<script>

export default {
  name: "RGE",
  props: [""],
  components: {},
  data: () => ({
    search: '',
    filter: {},
    sortDesc: false,
    page: 1,
    itemsPerPage: 10,
  }),
  computed: {

    certif_rge: function () {
      return this.$store.getters.getbloc("certificats", "donnees", "rge_certif", null, "valeur")

    }

  },
  methods: {
    condition() {
      var certif = this.certif_rge
      // var etabs = this.etabs_rge
      return (certif != null &&  certif.qualifications!=null && certif.qualifications.length > 0) //|| (etabs != null && etabs.length > 0)
    },
    displaySelected(siret) {
      this.$store.dispatch('getEtablissement', siret)
    },
  },
};
</script>
